import * as React from 'react';
import { Col, FormGroup, ControlLabel, Form, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { Link } from 'react-router-dom';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { flow } from 'lodash';
import { FaCog } from 'react-icons/fa';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';

interface ILoginFormProps extends InjectedFormProps {
  actions: {
    push: (route: string) => void;
  };
}

class LoginForm extends React.Component<ILoginFormProps> {
  private handleCreateAnAccount = () => {
    const { actions } = this.props;

    actions.push('/auth/create-an-account');
  }

  public render() {
    const { handleSubmit, submitting } = this.props;

    return (
      <Form horizontal={true} onSubmit={handleSubmit} method="post" autoComplete="off">
        <div className="blue-section-group">
          <div className="blue-section">
            <FormGroup controlId="email">
              <Col componentClass={ControlLabel} sm={3}>
                Email
              </Col>
              <Col sm={5}>
                <Field
                  id="email"
                  name="email"
                  type="email"
                  component={FieldFormControl}
                  tabIndex={1}
                />
              </Col>
            </FormGroup>
          </div>
          <div className="blue-section">
            <FormGroup controlId="password">
              <Col componentClass={ControlLabel} sm={3}>
                Password
              </Col>
              <Col sm={5}>
                <Field
                  id="password"
                  name="password"
                  type="Password"
                  component={FieldFormControl}
                  tabIndex={2}
                />

                <div className="forgotten-password">
                  <Link to="/auth/remind">
                    Forgotten Password?
                  </Link>
                </div>
              </Col>
            </FormGroup>
          </div>
          <div className="blue-section">
            <FormGroup controlId="name">
              <Col componentClass={ControlLabel} sm={3}>
                Date of Birth
              </Col>
              <Col sm={4}>
                <Field
                  name={'dob'}
                  type="masked-date"
                  component={FieldFormControl}
                  placeholder="dd/mm/yyyy"
                  className="form-control"
                  tabIndex={3}
                />
              </Col>
            </FormGroup>
          </div>
        </div>
        <div className="btn-bar">
          <Button
            bsStyle="primary"
            type="submit"
            bsSize="lg"
            className="pull-right"
            disabled={submitting}
          >
            {submitting ? <FaCog className="fa-spin" /> : 'Sign In'}
          </Button>
          <div className="clearfix" />
          <div style={{ marginTop: '10px'}}>
            <Link to="/auth/create-an-account" className="pull-right underline">
              Not yet registered?
            </Link>
          </div>
        </div>
      </Form>
    );
  }
}

export default flow([
  reduxForm({
    form: 'login',
  }),
  connect(null,
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(LoginForm);
